import {
  CloseIcon,
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"

import useQuestReviewStore from "./useQuestReviewStore"

const QuestReviewEmptyState = () => {
  const { onClose } = useQuestReviewStore()

  return (
    <>
      <button
        onClick={onClose}
        style={{
          padding: `${SPACING.space4} ${SPACING.space4}`,
          marginLeft: "auto",
        }}
      >
        <CloseIcon color={JoonUIColor.icon.neutral} size={24} />
      </button>
      <FlexBox
        direction="column"
        justify="space-between"
        align="center"
        style={{
          height: "min(600px, calc(100vh - 80px))",
          padding: `${SPACING.space14} ${SPACING.space6} ${SPACING.space6}`,
        }}
      >
        <div className="flex flex-col items-center gap-2">
          <img
            src="/images/party_popper.gif"
            alt="party-popper"
            className="w-16 h-16 mb-4"
          />
          <Typography variant="bodyBold" textAlign="center">
            You've approved all Quests!
          </Typography>
          <Typography variant="bodySmall" textAlign="center">
            Your children have earned some coins from these quests which they
            can collect from the mailman in their Joon Game App!
          </Typography>
          <img
            src="/images/redeem_from_mailman.png"
            alt="redeem-from-mailman"
            className="w-full"
          />
        </div>
      </FlexBox>
    </>
  )
}

export default QuestReviewEmptyState
